import { app } from '../../../../../../app';
import { Controller } from './remove-users-from-label.controller';

app.component('companyUserLabelMembersRemove', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./remove-users-from-label.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/remove/remove-users-from-label.component.js